<template>
    <div>
        <form-with-data :isEdit="isEdit" :id="id" ref="form" @submitLoad="submitLoad"></form-with-data>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="loading">确认发送</el-button>
        </div>
    </div>
</template>
<script>
import formWithData from './withData'
export default {
  components: {
    formWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.submit()
    },
    submitLoad (val) {
      this.loading = val
    }
  }
}
</script>
<style module lang="less">

</style>
